import { useState } from 'react';

const WA_NUMBER = '905364322518';
const WA_MESSAGE = 'Merhaba, yedek parça hakkında bilgi almak istiyorum.';

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);

  const waUrl = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_MESSAGE)}`;

  return (
    <a
      href={waUrl}
      target="_blank"
      rel="nofollow noreferrer"
      aria-label="WhatsApp ile iletişime geç"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 cursor-pointer group"
    >
      {/* Tooltip */}
      <div
        className={`bg-gray-900 text-white text-sm font-medium px-4 py-2 rounded-lg whitespace-nowrap transition-all duration-300 ${
          hovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-2 pointer-events-none'
        }`}
      >
        WhatsApp&apos;tan Yazın
        <div className="absolute right-[-6px] top-1/2 -translate-y-1/2 w-0 h-0 border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent border-l-[6px] border-l-gray-900"></div>
      </div>

      {/* Button */}
      <div className="relative w-14 h-14 flex items-center justify-center bg-[#25D366] hover:bg-[#1ebe5d] rounded-full transition-all duration-300 hover:scale-110">
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30"></span>
        <i className="ri-whatsapp-line text-white text-3xl relative z-10"></i>
      </div>
    </a>
  );
}
